module.exports = __webpack_public_path__ + "static/media/bottom-up-background.243c04d8.png";